import type { StressAssessmentSchedulePresentation } from '../presentations';
import type { MonthOption, MonthRow } from '../types';

type PresentationProps = React.ComponentProps<typeof StressAssessmentSchedulePresentation>;

const ALL_MONTHS: MonthOption[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const convertRowsToScheduleProps = (
  rows: MonthRow[]
): Pick<PresentationProps, 'monthRows' | 'isAddDisabled'> => ({
  monthRows: rows.map(row => ({
    ...row,
    availableMonths: ALL_MONTHS.filter(
      m => m === row.month || !rows.some(r => r.id !== row.id && r.month === m)
    ),
  })),
  isAddDisabled: rows.length >= 12,
});
